export default "__VITE_ASSET__CFH0xPy9__"